export const modal = () => {
  document.querySelectorAll('.modalButton').forEach((modalButton) => {
    modalButton.addEventListener('click', (e) => {
      e.preventDefault();
      const targetModal = e.currentTarget.getAttribute('data-modalButton');
      document.querySelectorAll('.modalBlock').forEach((modalBlock) => {
        if (modalBlock.getAttribute('data-modalWindow') === targetModal) {
          gsap.to(modalBlock, {
            onStart: () => {
              document.querySelector('.modalContents').style.display = 'flex';
              modalBlock.style.display = 'block';
            },
            duration: 0.5,
            ease: 'expo.out',
            autoAlpha: 1,
          })
          const modalClose = () => {
            gsap.to('.modalContents', {
              duration: 0.7,
              ease: 'expo.out',
              autoAlpha: 0,
              onComplete: () => {
                document.querySelector('.modalContents').style.display = 'none';
                document.querySelector('.modalContents').style.visibility = 'visible';
                document.querySelector('.modalContents').style.opacity = 1;
                modalBlock.style.display = 'none';
                modalBlock.style.visibility = 'hidden';
                modalBlock.style.opacity = 0;
              }
            })
          }
          if (modalBlock.querySelector('.modalCloseTop') !== null) {
            modalBlock.querySelector('.modalCloseTop').addEventListener('click', () => {
              modalClose();
            });
          }
          if (modalBlock.querySelector('.modalClose') !== null) {
            modalBlock.querySelector('.modalClose').addEventListener('click', () => {
              modalClose();
            });
          }
          document.querySelector('.modalContents').addEventListener('click', () => {
            modalClose();
          });
        }
      });
    });
  });
}
